<ng-container
  *ngIf="bankProposalData.bankProposalStatisticsForMaturities && bankProposalData.bankProposalStatisticsForMaturities.length > 0;else noData">
  <div class="card-header">
  <div class="grid-x">
    <div class="cell auto">
      <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">{{"widget.name.".concat(widget.widgetName) | translate}}</h4>
    </div>
    <div class="cell shrink">
    </div>
  </div>
</div>
<div class="card-body vertical-center">

  <div class="d-block padding-h-s">
    <div class="d-block margin-b-s">
      <span [ngStyle]="{'visibility': isFirstMaturiy() ? 'hidden' : 'visible'}"
            class="cursor-hover fas fa-arrow-alt-circle-left padding-r-xs c-medium-gray"
            (click)="previousMaturity()"></span>
      <span class="c-dark-gray margin-b-xs i-block" style="font-weight:500;">
        {{'widget.bank-proposal.small.maturity' | translate:{'maturity': currentMaturity} }}
      </span>
      <span (click)="nextMaturity()"
            [ngStyle]="{'visibility': isLastMaturiy() ? 'hidden' : 'visible'}"
            class="cursor-hover fas fa-arrow-alt-circle-right padding-l-xs c-medium-gray"></span>
    </div>
    <div [chart]="chart" class="d-block" id="jdoChart" style="height: 78px;width: 98%"></div>
  </div>
</div>
<div class="card-footer">
  <a *ngIf="isAssistanceEnabled" (click)="redirectToAssistance()" class="button insito">
    <span [title]="'widget.bank-proposal.discover-opportunity' | translate">{{'widget.bank-proposal.discover-opportunity' | translate}}</span>
  </a>
  <a *ngIf="!isAssistanceEnabled" (click)="redirectToInsitoIfHasAccessOrElseBankProposal()" class="button insito">
    <span *ngIf="insitoAccountId !== undefined" [title]="'widget.bank-proposal.discover-opportunity' | translate">{{'widget.bank-proposal.discover-opportunity' | translate}}</span>
    <span *ngIf="insitoAccountId === undefined" [title]="'widget.bank-proposal.discover-offers' | translate">{{'widget.bank-proposal.discover-offers' | translate}}</span>
  </a>
</div>
</ng-container>
<ng-template #noData>
  <app-widget-message [message]="'widget.bank-proposal.no-data'| translate"
                      [widgetLabel]="'widget.name.'.concat(widget.widgetName) | translate"
                      [widgetSize]="widget.size"
                      icone="opt-stat"></app-widget-message>
</ng-template>


